import * as React from "react";
import {ShoppingBasket} from "../../models/ShoppingBasket";
import {ShoppingBasketLineItem } from "../../models/ShoppingBasketLineItem";
import {Product} from "../../models/Product";
import {Customer} from "../../models/Customer";
import {MoneyDisplay} from "../common/MoneyDisplay";
import {TextBox} from "../common/TextBox";


export interface CartLineItemProp
{
	customer: Customer;
	lineItem: ShoppingBasketLineItem;
	removeLineItem: (lineItem: ShoppingBasketLineItem) => void;
	adjustLineItemQty: (lineItem: ShoppingBasketLineItem, amount: number) => void;
	allowLineItemEdits: boolean;
}

export interface CartLineItemState
	{}

export class CartLineItem extends React.Component<CartLineItemProp, CartLineItemState>
{
	render()
	{
		const lineItem = this.props.lineItem;
		const product = lineItem.product;
		return <div className="line-item-row">
			       <div className="col-lg-3 col-md-4 col-sm-4 col-xs-5">
				       {this.renderImage(product)}
			       </div>
			       <div className="col-lg-6 col-md-4 col-sm-4 col-xs-7">
				       <h4>{product.name}</h4>
				       <div className="shopping-basket-sku">
					       <b>SKU</b>
					       <span> {product.sku}</span>
				       </div>
				       {(() =>
                {
	                if (product.mfgsku)
	                {
		                return <div>
                            <b>MFG Model</b>
                            <span> {product.mfgsku}</span>
                        </div>;
	                }
	                return null;
                })() }

				       <div className="hidden-xs" dangerouslySetInnerHTML={{ __html: product.shortDescription }}/>
				       {this.renderImportantNotes(product) }
			       </div>
				   <div className="col-lg-3 col-md-4 col-sm-4 col-xs-12">
					<div className="col-lg-8 col-md-6 col-sm-6 col-xs-6">
						{this.renderQuantityBox(lineItem, product) }
					</div>
					<div className="shoppingbasket-lineitem-prices col-lg-4 col-md-6 col-sm-6 col-xs-6">
						{this.renderPrice(lineItem) }
						{this.renderRemoveButton(lineItem) }
					</div>
				   </div>
		       </div>;
	}
	private renderImage(product: Product)
	{
		if (product.mainPhotoPath)
			return <img className="img-responsive cart-line-image" src={`/${product.mainPhotoPath}` }/>;
		return null;
	}
	private renderQuantityBox(lineItem: ShoppingBasketLineItem, product: Product)
	{
		if (!this.props.allowLineItemEdits)
		{
			var ctrlId = product.sku + "qty";
			return <div>
				       <label htmlFor={ ctrlId }>
					       QTY
				       </label>
				       <div className="shoppingbasket-qty" id={ ctrlId }>
					       { lineItem.quantity.toString() }
				       </div>
			       </div>;
		}

		return <TextBox inputClassName="shoppingbasket-qty"
						fieldName={product.sku + "qty"}
						type="number"
						value={lineItem.quantity.toString() }
						label="QTY"
						onChange={(ev: React.FormEvent<any>) => this.props
							.adjustLineItemQty(lineItem, parseInt(ev.target.value as string)) }/>;
	}

	private renderRemoveButton(lineItem: ShoppingBasketLineItem)
	{
		if (!this.props.allowLineItemEdits)
		{
			return null;
		}

		return <a className="btn btn-danger" onClick={() =>
        {
	        this.props.removeLineItem(lineItem);
        } }>Remove</a>;
	}

	private renderImportantNotes(product: Product)
	{
		if (product.importantNotes && product.importantNotes.length > 0)
		{
			var notesId = `important-notes-${product.sku}`;
			return <div>
				       <p>
					       <button onClick={() =>
                    {
	                    this.handleImportantNotesCollapse(notesId);
                    } } className="btn btn-warning" type="button">
						       View Important Information
					       </button>
				       </p>
				       <div className="collapse" id={notesId}>
					       <div className="well">
						       <div dangerouslySetInnerHTML={{ __html: product.importantNotes }}/>
					       </div>
				       </div>
			       </div>;
		}
		return null;
	}

	private handleImportantNotesCollapse(elementId: string)
	{
		$(`#${elementId}`).collapse("toggle");
	}

	private renderPrice(lineItem: ShoppingBasketLineItem)
	{
		if (lineItem.hasDiscount)
		{
			return <div>
				       <MoneyDisplay className="shoppingbasket-price" amount={lineItem.discountPrice}/>
				       <div className="shoppingbasket-discountprice-orig">
					       Orig <del>
						       <MoneyDisplay amount={lineItem.originalPrice}/>
					       </del>
				       </div>
			       </div>;
		}
		return <div className="shoppingbasket-price">
			       <MoneyDisplay amount={lineItem.originalPrice}/>
		       </div>;
	}
}


// WEBPACK FOOTER //
// ./src/components/shoppingbasket/CartLineItem.tsx